<template>
  <div id="app">
    <div class="app-wrap">
      <div class="header hidden-mobile" v-if="!isAdmin">
        <div class="header-menu pure-menu pure-menu-horizontal pure-menu-fixed">
          <router-link to="/" class="pure-menu-heading press-home-link" v-on:click.native="homeClick()" v-if="isPress"><i class="fal fa-home"></i> <span>Press</span></router-link>
          <router-link to="/" class="pure-menu-heading home-link" v-on:click.native="homeClick()" v-else><i class="fal fa-home"></i></router-link>
          <div class="pure-menu-search">
            <input id="search-grapes" type="text" v-model="query" v-on:keyup.enter="search" placeholder="Search grapevine" />
            <div v-on:click="search" class="search-trigger"><i class="fal fa-search"></i></div>
          </div>
          <ul class="pure-menu-list" v-if="isPress">
              <li class="pure-menu-item" v-if="isLoggedIn"><router-link v-on:click.native="desktopMenuClick()" to="/add" class="pure-menu-link">New Grape</router-link></li>
              <li class="pure-menu-item account-menu-item"><router-link v-on:click.native="desktopMenuClick()" to="/account" class="pure-menu-link">{{usernameMenuItem}}</router-link></li>
          </ul>
          <ul class="pure-menu-list" v-else>
            <li class="pure-menu-item" v-if="isLoggedIn"><router-link v-on:click.native="desktopMenuClick()" to="/add" class="pure-menu-link">New Grape</router-link></li>
            <li class="pure-menu-item pure-menu-has-children pure-menu-allow-hover account-menu-item" v-if="isLoggedIn"><router-link v-on:click.native="desktopMenuClick()" v-bind:to="{ name: 'user', params: { username: username }}" class="pure-menu-link">{{usernameMenuItem}}</router-link>
              <ul class="pure-menu-children">
                <li class="pure-menu-item"><router-link v-on:click.native="desktopMenuClick()" v-bind:to="{ name: 'user', params: { username: username }}" class="pure-menu-link">Profile</router-link></li>
                <li class="pure-menu-item"><router-link v-on:click.native="desktopMenuClick()" to="/account" class="pure-menu-link">Account</router-link></li>
                <li class="pure-menu-item"><a href="#" v-on:click.stop.prevent="logOut()"  class="pure-menu-link">Log out</a></li>
              </ul>
            </li>
            <li class="pure-menu-item account-menu-item" v-else><router-link v-on:click.native="desktopMenuClick()" to="/account" class="pure-menu-link">{{usernameMenuItem}}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="header visible-mobile" v-if="!isAdmin">
        <div class="header-menu mobile-menu pure-menu pure-menu-horizontal pure-menu-fixed">
          <router-link to="/" class="pure-menu-heading" v-on:click.native="homeClick()">Grapevine</router-link>
          <nav class="mobile-quick-nav" v-bind:class="{ mobileMenuShow: mobileMenuShowing, mobileSearchShow: mobileSearchShowing }">
            <ul>
              <li class="home"><router-link to="/" v-on:click.native="homeClick()" class="pure-menu-link"><i class="fal fa-home"></i><span>Home</span></router-link></li>
              <li class="search"><a href="#" v-on:click.stop.prevent="mobileShowSearch()"><i class="fal fa-search"></i><span>Search</span></a></li>
              <li class="envelope"><a href="#" v-on:click.stop.prevent="mobileShowMessages()"><i class="fal fa-envelope"></i><span>Messages</span></a></li>
              <li class="profile"><router-link to="/account" class="pure-menu-link" v-on:click.native="menuClick()"><i class="fal fa-user"></i><span>Profile</span></router-link></li>
              <li class="back" v-on:click.stop.prevent="hideMobileMenu()"><a href="#"><i class="fal fa-times"></i></a></li>
            </ul>
            <div class="mobile-search">
              <input id="mobile-search-grapes" type="search" v-model="query" v-on:keyup.enter="search" placeholder="Search here" />
              <div v-on:click="search" class="search-trigger"><i class="fal fa-search"></i></div>
            </div>
          </nav>
          <ul class="pure-menu-list">
            <li class="pure-menu-item grapevines"><a href="#" v-on:click.stop.prevent="mobileShowGrapevines()"><span><svg enable-background="new 0 0 144.083 144" version="1.1" viewBox="0 0 144.083 144" width="144.083px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M105.793,66.041c0-6.709-5.459-12.167-12.168-12.167c-4.725,0-8.818,2.712-10.832,6.655  c-1.656-3.239-4.711-5.648-8.371-6.404c-0.135-1.278-0.727-8.613,3.012-12.896c1.846-2.115,4.547-3.188,8.025-3.188v-3  c-4.389,0-7.854,1.422-10.295,4.226c-0.484,0.556-0.893,1.152-1.266,1.765c-0.746-3.521-2.378-7.913-5.968-10.595v0.001  c-6.592-4.928-16.864-1.894-17.298-1.762l-1.056,0.32l-0.008,1.104c-0.003,0.453-0.005,11.165,6.59,16.091  c2.926,2.188,6.577,2.807,9.771,2.807c2.207,0,4.192-0.295,5.573-0.573c-0.286,2.358-0.204,4.39-0.114,5.479  c-4.48,0.21-8.328,2.844-10.261,6.626c-2.015-3.943-6.109-6.655-10.833-6.655c-6.709,0-12.167,5.458-12.167,12.167  s5.458,12.167,12.167,12.167c0.684,0,1.35-0.07,2.003-0.18c-2.063,2.182-3.337,5.114-3.337,8.346  c0,6.709,5.458,12.167,12.167,12.167c0.623,0,1.229-0.062,1.828-0.152c-1.958,2.16-3.162,5.015-3.162,8.152  c0,6.709,5.458,12.167,12.167,12.167c6.708,0,12.167-5.458,12.167-12.167c0-3.138-1.205-5.992-3.162-8.152  c0.598,0.091,1.205,0.152,1.828,0.152c6.709,0,12.166-5.458,12.166-12.167c0-3.231-1.273-6.164-3.336-8.346  c0.652,0.109,1.318,0.18,2.002,0.18C100.334,78.208,105.793,72.75,105.793,66.041z M57.954,43.788  c-4.259-3.181-5.15-9.846-5.336-12.521c2.614-0.582,9.246-1.618,13.518,1.573l0,0.001c4.26,3.182,5.15,9.847,5.337,12.521  C68.857,45.945,62.227,46.982,57.954,43.788z M84.795,74.387c-0.652-0.109-1.318-0.18-2.002-0.18s-1.35,0.07-2.004,0.18  c0.797-0.842,1.473-1.794,2.004-2.834C83.325,72.593,84,73.545,84.795,74.387z M71.96,56.874c5.054,0,9.167,4.112,9.167,9.167  s-4.113,9.167-9.167,9.167c-5.055,0-9.167-4.112-9.167-9.167S66.905,56.874,71.96,56.874z M69.957,78.028  c0.653,0.109,1.319,0.18,2.003,0.18c0.683,0,1.349-0.07,2.003-0.18c-0.797,0.842-1.472,1.794-2.003,2.834  C71.429,79.822,70.753,78.87,69.957,78.028z M73.788,94.526c-0.598-0.091-1.205-0.152-1.828-0.152c-0.623,0-1.229,0.062-1.827,0.152  c0.719-0.794,1.335-1.679,1.827-2.641C72.452,92.848,73.069,93.732,73.788,94.526z M63.13,74.387  c-0.653-0.109-1.319-0.18-2.003-0.18s-1.35,0.07-2.003,0.18c0.796-0.842,1.471-1.794,2.003-2.834  C61.659,72.593,62.334,73.545,63.13,74.387z M50.294,75.208c-5.055,0-9.167-4.112-9.167-9.167s4.112-9.167,9.167-9.167  s9.167,4.112,9.167,9.167S55.349,75.208,50.294,75.208z M61.127,95.541c-5.055,0-9.167-4.112-9.167-9.167s4.112-9.167,9.167-9.167  s9.167,4.112,9.167,9.167S66.182,95.541,61.127,95.541z M81.127,106.541c0,5.055-4.113,9.167-9.167,9.167  c-5.055,0-9.167-4.112-9.167-9.167s4.112-9.167,9.167-9.167C77.014,97.374,81.127,101.486,81.127,106.541z M91.959,86.374  c0,5.055-4.111,9.167-9.166,9.167s-9.168-4.112-9.168-9.167s4.113-9.167,9.168-9.167S91.959,81.319,91.959,86.374z M84.459,66.041  c0-5.055,4.111-9.167,9.166-9.167s9.168,4.112,9.168,9.167s-4.113,9.167-9.168,9.167S84.459,71.096,84.459,66.041z" fill="#fff" /></svg></span></a></li>
            <li class="pure-menu-item create-grape" v-if="user"><router-link to="/add" class="pure-menu-link" v-on:click.native="menuClick()"><span><svg enable-background="new 0 0 32 32" height="32px" version="1.1" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Upload"><path d="M31,21.996c-0.552,0-1,0.448-1,1v7H2v-7c0-0.552-0.448-1-1-1s-1,0.448-1,1v8c0,0.552,0.448,1,1,1h30   c0.552,0,1-0.448,1-1v-8C32,22.443,31.552,21.996,31,21.996z" fill="#fff"/><path d="M9.731,8.602l5.275-5.2v19.593c0,0.552,0.452,1,1.01,1c0.558,0,1.01-0.448,1.01-1V3.402l5.275,5.2   c0.394,0.391,1.034,0.391,1.428,0s0.395-1.024,0-1.414L16.73,0.289c-0.39-0.387-1.046-0.383-1.429,0L8.303,7.188   c-0.395,0.391-0.394,1.024,0,1.414C8.697,8.993,9.337,8.993,9.731,8.602z" fill="#fff"/></g><g/><g/><g/><g/><g/><g/></svg></span></router-link></li>
            <li class="pure-menu-item open-menu-item"><a href="#" v-on:click.stop.prevent="showMobileMenu()"><i class="fas fa-bars"></i></a></li>
          </ul>
        </div>
        <div id="mobile-header-progress"></div>
      </div>
      <div class="header admin-header" v-if="isAdmin">
        <div class="header-menu pure-menu pure-menu-horizontal pure-menu-fixed">
          <router-link to="/" class="pure-menu-heading" v-on:click.native="homeClick()">Grapevine <span>ADMIN</span></router-link>
          <ul class="pure-menu-list">
              <li class="pure-menu-item" v-if="user"><router-link to="/admin/grapes" class="pure-menu-link">Grapes</router-link></li>
              <li class="pure-menu-item" v-if="user"><router-link to="/admin/grapevines" class="pure-menu-link">Grapevines</router-link></li>
              <li class="pure-menu-item" v-if="user"><router-link to="/admin/ocr" class="pure-menu-link">OCR</router-link></li>
              <li class="pure-menu-item" v-if="user"><router-link to="/admin/lists" class="pure-menu-link">Lists</router-link></li>
              <li class="pure-menu-item" v-if="user"><router-link to="/admin/mailchimp" class="pure-menu-link">Mail</router-link></li>
              <li class="pure-menu-item" v-if="user"><router-link to="/admin/twitter" class="pure-menu-link">Twitter</router-link></li>
              <li class="pure-menu-item" v-if="user"><router-link to="/admin/flags" class="pure-menu-link">Flags</router-link></li>
              <li class="pure-menu-item account-menu-item"><router-link to="/account" class="pure-menu-link">{{usernameMenuItem}}</router-link></li>
          </ul>
        </div>
      </div>
      <div id="left-col-trigger">
        <a href="#" class="trigger"><span><svg enable-background="new 0 0 144.083 144" version="1.1" viewBox="0 0 144.083 144" width="144.083px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M105.793,66.041c0-6.709-5.459-12.167-12.168-12.167c-4.725,0-8.818,2.712-10.832,6.655  c-1.656-3.239-4.711-5.648-8.371-6.404c-0.135-1.278-0.727-8.613,3.012-12.896c1.846-2.115,4.547-3.188,8.025-3.188v-3  c-4.389,0-7.854,1.422-10.295,4.226c-0.484,0.556-0.893,1.152-1.266,1.765c-0.746-3.521-2.378-7.913-5.968-10.595v0.001  c-6.592-4.928-16.864-1.894-17.298-1.762l-1.056,0.32l-0.008,1.104c-0.003,0.453-0.005,11.165,6.59,16.091  c2.926,2.188,6.577,2.807,9.771,2.807c2.207,0,4.192-0.295,5.573-0.573c-0.286,2.358-0.204,4.39-0.114,5.479  c-4.48,0.21-8.328,2.844-10.261,6.626c-2.015-3.943-6.109-6.655-10.833-6.655c-6.709,0-12.167,5.458-12.167,12.167  s5.458,12.167,12.167,12.167c0.684,0,1.35-0.07,2.003-0.18c-2.063,2.182-3.337,5.114-3.337,8.346  c0,6.709,5.458,12.167,12.167,12.167c0.623,0,1.229-0.062,1.828-0.152c-1.958,2.16-3.162,5.015-3.162,8.152  c0,6.709,5.458,12.167,12.167,12.167c6.708,0,12.167-5.458,12.167-12.167c0-3.138-1.205-5.992-3.162-8.152  c0.598,0.091,1.205,0.152,1.828,0.152c6.709,0,12.166-5.458,12.166-12.167c0-3.231-1.273-6.164-3.336-8.346  c0.652,0.109,1.318,0.18,2.002,0.18C100.334,78.208,105.793,72.75,105.793,66.041z M57.954,43.788  c-4.259-3.181-5.15-9.846-5.336-12.521c2.614-0.582,9.246-1.618,13.518,1.573l0,0.001c4.26,3.182,5.15,9.847,5.337,12.521  C68.857,45.945,62.227,46.982,57.954,43.788z M84.795,74.387c-0.652-0.109-1.318-0.18-2.002-0.18s-1.35,0.07-2.004,0.18  c0.797-0.842,1.473-1.794,2.004-2.834C83.325,72.593,84,73.545,84.795,74.387z M71.96,56.874c5.054,0,9.167,4.112,9.167,9.167  s-4.113,9.167-9.167,9.167c-5.055,0-9.167-4.112-9.167-9.167S66.905,56.874,71.96,56.874z M69.957,78.028  c0.653,0.109,1.319,0.18,2.003,0.18c0.683,0,1.349-0.07,2.003-0.18c-0.797,0.842-1.472,1.794-2.003,2.834  C71.429,79.822,70.753,78.87,69.957,78.028z M73.788,94.526c-0.598-0.091-1.205-0.152-1.828-0.152c-0.623,0-1.229,0.062-1.827,0.152  c0.719-0.794,1.335-1.679,1.827-2.641C72.452,92.848,73.069,93.732,73.788,94.526z M63.13,74.387  c-0.653-0.109-1.319-0.18-2.003-0.18s-1.35,0.07-2.003,0.18c0.796-0.842,1.471-1.794,2.003-2.834  C61.659,72.593,62.334,73.545,63.13,74.387z M50.294,75.208c-5.055,0-9.167-4.112-9.167-9.167s4.112-9.167,9.167-9.167  s9.167,4.112,9.167,9.167S55.349,75.208,50.294,75.208z M61.127,95.541c-5.055,0-9.167-4.112-9.167-9.167s4.112-9.167,9.167-9.167  s9.167,4.112,9.167,9.167S66.182,95.541,61.127,95.541z M81.127,106.541c0,5.055-4.113,9.167-9.167,9.167  c-5.055,0-9.167-4.112-9.167-9.167s4.112-9.167,9.167-9.167C77.014,97.374,81.127,101.486,81.127,106.541z M91.959,86.374  c0,5.055-4.111,9.167-9.166,9.167s-9.168-4.112-9.168-9.167s4.113-9.167,9.168-9.167S91.959,81.319,91.959,86.374z M84.459,66.041  c0-5.055,4.111-9.167,9.166-9.167s9.168,4.112,9.168,9.167s-4.113,9.167-9.168,9.167S84.459,71.096,84.459,66.041z" fill="#fff" /></svg></span></a>
      </div>
      <div class="tablet-sidebar-switch" v-if="!hideSidebars">
        <a href="#" v-on:click.stop.prevent="tabletSidebarSwitch('left')" class="lh-switch">Grapevines</a>
        <a href="#" v-on:click.stop.prevent="tabletSidebarSwitch('right')" class="rh-switch">Messages</a>
      </div>
      <LeftSidebar :hideSidebars="hideSidebars" />
      <router-view/>
      <RightSidebar :hideSidebars="hideSidebars" />
      <div class="pace-opt">
          <p>Converting your images into digital text. This shouldn’t take much longer than 10-15 secs.</p>
          <a href="#" class="cancel-ajax-ocr pure-button">Cancel</a>
      </div>
    </div>
  </div>
</template>

<script>
  /* global $ */
  import firebase from 'firebase'
  import Router from './router'
  import LeftSidebar from './components/LeftSidebar.vue'
  import RightSidebar from './components/RightSidebar.vue'

  export default {
    name: 'app',
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Grapevine',
      // all titles will be injected into this template
      titleTemplate: '%s | Grapevine'
    },
    data: function () {
      return {
        query: '',
        photo: '',
        userId: '',
        name: '',
        user: {},
        email: '',
        password: '',
        confirmPassword: '',
        loginEmail: '',
        loginPassword: '',
        username: '',
        isLoggedIn: false,
        usernameMenuItem: 'Log In / Sign Up',
        hideSidebars: false,
        isAdmin: false,
        mobileMenuShowing: false,
        mobileSearchShowing: false,
        mobileMessagesShowing: false,
        mobileGrapevinesShowing: true,
        isScrolling: false,
        isPress: this.$globals.isPress
      }
    },
    created () {
      var vm = this
      vm.checkPath()
      firebase.auth().onAuthStateChanged(function (user) {
        vm.user = null
        vm.name = ''
        vm.email = ''
        vm.photo = ''
        vm.userId = ''
        if (user) {
          vm.isLoggedIn = true
          vm.user = user
          vm.name = vm.user.displayName
          vm.email = vm.user.email
          vm.photo = vm.user.photoURL
          vm.userId = vm.user.uid
          vm.$globals.userId = vm.userId
          vm.$globals.userEmail = vm.user.email
          vm.$globals.userPhoto = vm.user.photoURL
          vm.checkUserRole(vm.userId)
          vm.getUsername(vm.userId)
        } else {
          vm.isLoggedIn = false
        }
      })
      this.$eventHub.$on('username-changed', function () {
        vm.getUsername(vm.userId)
      })
      this.$eventHub.$on('user-logged-out', function () {
        vm.userLoggedOut()
      })
      this.$eventHub.$on('grape-user-trigger', function (id, username) {
        console.log('grape user trigger')
        vm.tabletSidebarSwitch('right')
      })
      this.$eventHub.$on('grape-author-trigger', function (id, username) {
        console.log('grape author trigger')
        vm.tabletSidebarSwitch('left')
      })
      this.$eventHub.$on('grape-tags-trigger', function (id, title) {
        console.log('grape tags trigger')
        vm.tabletSidebarSwitch('right')
      })

      $(window).on('scroll', this.mobileCheckReadProgress)
    },
    beforeDestroy () {
      this.$eventHub.$off('username-changed')
      this.$eventHub.$off('user-logged-out')
      this.$eventHub.$off('grape-user-trigger')
      this.$eventHub.$off('grape-author-trigger')
      $(window).off('scroll', this.mobileCheckReadProgress)
    },
    watch: {
      '$route': 'checkPath'
    },
    methods: {
      checkPath: function () {
        let vm = this
        vm.isAdmin = false
        var windowWidth = $(window).width()
        if ((vm.$route.path === '/account' || vm.$route.path === '/privacy-policy') && windowWidth > 767) {
          vm.hideSidebars = true
        } else if ((vm.$route.path === '/add' || vm.$route.path === '/print/add') && windowWidth > 767) {
          vm.hideSidebars = true
        } else if (vm.$route.path.includes('/admin/')) {
          vm.hideSidebars = true
          vm.isAdmin = true
        } else if (vm.$route.path.includes('/edit-grape') && windowWidth > 767) {
          vm.hideSidebars = true
        } else {
          vm.hideSidebars = false
        }
        if (vm.$route.path !== '/') {
          $('#home-loading-overlay').remove()
        }
      },
      tabletSidebarSwitch: function (side) {
        console.log('tabletSidebarSwitch, side: ' + side)
        if (side === 'left') {
          $('body').addClass('tablet-view-lh')
          $('body').removeClass('tablet-view-rh')
        } else if (side === 'right') {
          $('body').removeClass('tablet-view-lh')
          $('body').addClass('tablet-view-rh')
        }
      },
      homeClick: function () {
        this.$eventHub.$emit('navigate-home')
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        if (this.mobileMessagesShowing) {
          this.mobileHideMessages()
        }
        if (this.mobileGrapevinesShowing) {
          this.mobileHideGrapevines()
        }
        this.mobileMenuShowing = false
      },
      desktopMenuClick: function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      },
      menuClick: function () {
        this.$eventHub.$emit('navigate-home')
        if (this.mobileMessagesShowing) {
          this.mobileHideMessages()
        }
        if (this.mobileGrapevinesShowing) {
          this.mobileHideGrapevines()
        }
        this.mobileMenuShowing = false
      },
      search: function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow')
        if (this.isPress) {
          Router.push({name: 'print-search', params: { term: this.query }})
        } else {
          Router.push({name: 'search', params: { term: this.query }})          
        }
        if (this.mobileSearchShowing) {
          this.mobileSearchShowing = false
          if (this.mobileGrapevinesShowing) {
            this.mobileHideGrapevines()
          }
          this.query = ''
        }
      },
      checkUserRole: function (uid) {
        var vm = this
        firebase.database().ref('user_roles/admin').once('value', function (snapshot) {
          if (snapshot.hasChild(uid)) {
            vm.$globals.userRole = 'admin'
            vm.$globals.userCanEditGrapes = true
            vm.$globals.userCanEditGrapevines = false
            vm.$eventHub.$emit('user-role-set')
          }
        })
      },
      getUsername: function (uid) {
        var vm = this
        firebase.database().ref('users/' + uid).once('value', function (snapshot) {
          var username = (snapshot.val() && snapshot.val().username)
          if (username !== '') {
            vm.$globals.userUsername = username
            vm.username = username
            vm.usernameMenuItem = '@' + username
            vm.$eventHub.$emit('user-username-set')
          }
        })
      },
      userLoggedOut: function () {
        this.usernameMenuItem = 'Log In / Signup'
      },
      showMobileMenu: function () {
        console.log('show mobile menu')
        this.mobileMenuShowing = true
      },
      hideMobileMenu: function () {
        console.log('hide mobile menu')
        this.mobileMenuShowing = false
        if (this.mobileSearchShowing) {
          this.mobileSearchShowing = false
        }
      },
      mobileShowSearch: function () {
        if (this.mobileSearchShowing) {
          this.mobileSearchShowing = false
        } else {
          this.mobileSearchShowing = true
        }
      },
      mobileShowMessages: function () {
        this.mobileMessagesShowing = true
        console.log('mobileShowMessages')
        this.$eventHub.$emit('mobile-message-show-trigger')
        this.mobileMenuShowing = false
      },
      mobileHideMessages: function () {
        this.mobileMessagesShowing = false
        this.$eventHub.$emit('mobile-message-hide-trigger')
      },
      mobileShowGrapevines: function () {
        this.mobileGrapevinesShowing = true
        if (this.mobileMessagesShowing) {
          this.mobileHideMessages()
        }
        this.$eventHub.$emit('mobile-grapevines-show-trigger')
      },
      mobileHideGrapevines: function () {
        this.mobileGrapevinesShowing = false
        this.$eventHub.$emit('mobile-grapevines-hide-trigger')
      },
      mobileCheckReadProgress: function () {
        let vm = this
        if (!vm.isScrolling && $('.selected-grape').length > 0) {
          vm.isScrolling = true
          if (!window.requestAnimationFrame) {
            setTimeout(vm.mobileUpdateReadProgress, 300)
          } else {
            window.requestAnimationFrame(vm.mobileUpdateReadProgress)
          }
        }
      },
      mobileUpdateReadProgress: function () {
        let vm = this
        let adjustment = 100
        let scrollTop = $(window).scrollTop() + adjustment
        let progress = $('#mobile-header-progress')

        var article = $('.selected-grape').find('.grape-content')
        var articleTop = article.offset().top
        var articleHeight = article.outerHeight()

        if (articleTop > scrollTop) {
          progress.css('width', 0)
        } else {
          var progressValue = 100 * ((scrollTop - articleTop) / articleHeight)
          progress.css('width', progressValue + '%')
        }
        vm.isScrolling = false
      },
      logOut: function () {
        this.$eventHub.$emit('user-logged-out')
        firebase.auth().signOut()
        this.isLoggedIn = false
        this.usernameMenuItem = 'Log In / Sign Up'
        Router.push('/')
      }
    },
    mounted: function () {
      $(document).on('click', '#left-col-trigger > .trigger', function () {
        if ($('body').hasClass('left-col-overlay-open')) {
          $('body').addClass('body-overlay-transition')
          $('#left-col,#right-col,.tablet-sidebar-switch').transition({
            left: -256,
            delay: 0,
            duration: 600,
            complete: function () {
              $('body').removeClass('body-overlay body-overlay-transition')
            }
          });
          $('body').removeClass('left-col-overlay-open')
          $('#left-col-trigger').transition({
            left: 0,
            delay: 0,
            duration: 600
          });
        } else {
          $('body').addClass('body-overlay')
          $('#left-col,#right-col,.tablet-sidebar-switch').transition({
            left: 0,
            delay: 0,
            duration: 600,
            complete: function () {
            }
          });
          $('body').addClass('left-col-overlay-open')
          $('#left-col-trigger').transition({
            left: 256,
            delay: 0,
            duration: 600
          });
        }
      })
    },
    components: {
      LeftSidebar,
      RightSidebar
    }
  };
</script>

<style>
@media only screen and (max-width: 1023px) {
  html.fixed, html.fixed > body {
    overflow: hidden;
    height: 100%;
    position: fixed;
  }
}
html.pace-running {
  overflow: hidden;
  height: 100%;
  position: fixed;
}
html.pace-running > body {
  overflow-y: scroll;
  height: 100%;
  width: 100%;
  position: fixed;
}
body {
  background: #fff;
}
body.overlay-panel-visible, body.is-editing-inline {
  height: auto;
  overflow: hidden;
}
a {
  color: #1d5094;
}
a:visited {
  color: #1d5094;
}
input {
  -webkit-appearance: none;
}
#home-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 1;
  z-index: 3;
}
#home-loading-overlay .logo-wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -150px;
  margin-left: -400px;
  text-align: center;
}
#home-loading-overlay .logo-wrap img {
  display: inline-block;
}
@media only screen and (max-width: 1023px) {
  #home-loading-overlay .logo-wrap {
    width: 600px;
    margin-left: -300px;
  }
  #home-loading-overlay .logo-wrap img {
    max-width: 80%;
  }
}
@media only screen and (max-width: 767px) {
  #home-loading-overlay .logo-wrap {
    width: 300px;
    margin-left: -150px;
  }
}
#home-loading-overlay + .pace {
  display: none;
}
.pace {
  width: 80px;
  height: 80px;
  position: fixed;
  top: 30px;
  right: 30px;
  margin-left: 0;
  margin-top: 0;
  z-index: 2000;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 30px -4px rgba(0,0,0,0.3);
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transform: scale(0);
  opacity: 0;
  -webkit-transition: all 0.3s linear 0s;
  -moz-transition: all 0.3s linear 0s;
  transition: all 0.3s linear 0s;
}
.pace.pace-active {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
  opacity: 1;
}
.pace .spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -11px 0 0 -35px;
  transform: scale(0.7);
}
.spinner {
  margin: 100px auto 0;
  width: 70px;
  text-align: center;
}
.spinner > div {
  width: 18px;
  height: 18px;
  background-color: #333;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 2.5s infinite ease-in-out both;
  animation: sk-bouncedelay 2.5s infinite ease-in-out both;
}
.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}
@keyframes sk-bouncedelay {
  0%, 80%, 100% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% { 
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
.pace-opt {
  position: fixed;
  top: 120px;
  right: 30px;
  max-width: 300px;
  z-index: 99;
  display: none;
  opacity: 0;
  background: #fff;
  border-radius: 5px;
  padding: 20px;
  box-shadow: 0px 0px 30px -4px rgba(0,0,0,0.3);
}
.pace-opt.show-opt {
  display: block;
  opacity: 1;
}
.pace-opt p {
  margin: 0;
}
.pace-opt .pure-button {
  display: none;
  backface-visibility: hidden;
}
.pace-opt.show-opt .pure-button {
  display: inline-block;
  margin-top: 10px;
  background: #36a731;
  color: #fff;
  width: 80px;
  text-align: center;
  padding: 10px 0;
}
.tablet-sidebar-switch {
  position: fixed;
  top: 53px;
  left: 0;
  width: 25%;
  height: 80px;
  line-height: 80px;
  font-size: 0;
  z-index: 4;
  display: none;
  background: #f9f9f9;
}
.tablet-sidebar-switch > a {
  width: 50%;
  font-size: 17px;
  font-weight: 100;
  color: #666;
  text-align: center;
  display: inline-block;
  box-sizing: border-box;
  text-decoration: none;
  opacity: 0.5;
}
body:not(.tablet-view-rh) .tablet-sidebar-switch > a.lh-switch {
  text-decoration: underline;
  opacity: 1;
}
.tablet-view-rh .tablet-sidebar-switch > a.rh-switch {
  text-decoration: underline;
  opacity: 1;
}
.pure-button {
  padding: 10px 20px;
  font-weight: bold;
  border-radius: 0;
}
.pure-button.accent {
  background: #36a731;
  color: #fff;
}
.pure-button.accent:hover {
  opacity: 0.7;
}
.context-menu-list {
  padding-top: 0;
  padding-bottom: 0;
}
.context-menu-item {
  padding: .5em 1em;
  line-height: 150%;
}
.video-wrap {
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
}
.video-wrap:empty {
  display: none;
}
.video-wrap iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%!important;
  height: 100%!important;
}
#main-col {
  background: #fff;
  box-sizing: border-box;
  padding: 30px 20px;
  width: 100%;
}
.visible-mobile {
  display: block;
}
.hidden-mobile {
  display: none;
}
@media only screen and (min-width: 1200px) {
  .visible-mobile {
    display: none;
  }
  .hidden-mobile {
    display: block;
  }
  #main-col {
    margin-left: 17%;
    width: 63%;
    background: #fff;
    padding: 30px;
    box-sizing: border-box;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1199px) {
  .tablet-sidebar-switch {
    display: block;
  }
  .visible-mobile {
    display: none;
  }
  .hidden-mobile {
    display: block;
  }
  #main-col {
    margin-left: 25%;
    width: 75%;
    background: #fff;
    padding: 30px;
    box-sizing: border-box;
  }
}
#left-col-trigger {
  display: none;
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  #left-col-trigger {
    display: block;
    background: #fff;
    position: fixed;
    z-index: 100;
    top: 50%;
    left: 0;
    box-shadow: 5px 5px 36px -12px rgba(0,0,0,0.5); 
  }
  #left-col-trigger svg {
    width: 48px;
  }
  #left-col-trigger svg path {
    fill: #222;
  }
  .tablet-sidebar-switch {
    position: fixed;
    z-index: 98;
    top: 53px;
    left: -256px;
    display: block;
    width: 246px;
    border-right: 10px solid #fff;
  }
  /*.left-col-overlay-open .tablet-sidebar-switch {
    box-shadow: 5px 5px 36px -12px rgba(0,0,0,0.5);
  }*/
  .visible-mobile {
    display: none;
  }
  .hidden-mobile {
    display: block;
  }
  #main-wrap::after {
    content: '';
    position: fixed;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    background: rgba(0,0,0,0.4);
    opacity: 0;
    z-index: 92;
    cursor: pointer;
    -webkit-transition: opacity 0.5s;
    transition: opacity 0.5s;
  }
  .body-overlay #main-wrap::after {
    opacity: 1;
    width: 100%;
    height: 100%;
  }
  .body-overlay-transition #main-wrap::after {
    opacity: 0;
  }
}
.noty_theme__metroui.noty_type__success {
  background-color: #428921;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}

@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
}

.switch {
  position: relative;
  display: block;
  vertical-align: top;
  width: 100%;
  height: 42px;
  margin: 0 10px 10px 0;
  cursor: pointer;
  box-sizing: border-box;
}
.switch-input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  box-sizing:content-box;
}
.switch-label {
  position: relative;
  display: block;
  height: inherit;
  font-size: 16px;
  background: #bbb;
  box-sizing: border-box;
  font-family: Font Awesome\ 5 Pro, Calibri, 'PT Sans', Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
}
.switch-label:before, .switch-label:after {
  position: absolute;
  top: 50%;
  margin-top: -10px;
  font-weight: 100;
  -webkit-transition: inherit;
  -moz-transition: inherit;
  -o-transition: inherit;
  transition: inherit;
  box-sizing:content-box;
}
.switch-label:before {
  content: 'Public \f09c';
  right: 12px;
  color: #fff;
  word-spacing: 4px;
}
.switch-label:after {
  content: '\f023 Private';
  left: 12px;
  color: #fff;
  opacity: 0;
  word-spacing: 4px;
}
.switch-input:checked ~ .switch-label {
  background: #8b949c;
}
.switch-input:checked ~ .switch-label:before {
  opacity: 0;
}
.switch-input:checked ~ .switch-label:after {
  opacity: 1;
}
.switch-handle {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 38px;
  background: #8b949c;
}
.switch-input:checked ~ .switch-handle {
  left: 80%;
  background: #bbb;
  left: calc(100% - 18px);
}
@media only screen and (min-width: 1200px) and (max-width: 1600px) {
  #left-col .switch-label:before {
    content: 'Public';
    right: 8px;
  }
  #left-col .switch-label:after {
    content: 'Private';
    left: 8px;
  }
}

/* Transition
========================== */
.switch-label, .switch-handle {
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition-delay: 0.3s;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
  padding-top: 50px;
  opacity: 1;
  transition: all 0.4s ease-in-out;
  background: #fff;
  z-index: 2;
  position: relative;
}
#app, .pure-g [class*=pure-u], .grape .grape-content, .grape .grape-content span, .grape .grape-content p, .ui-widget, .ui-widget input, .ui-widget select, .ui-widget textarea, .ui-widget button, .context-menu-item {
  font-family: Calibri, 'PT Sans', Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
}
.header-menu {
  background: #485057;
  text-align: left;
  z-index: 999;
}
.header-menu .pure-menu-heading {
  padding: 13px;
  color: #fff;
  font-size: 20px;
  float: left;
  margin-left: 5px;
}
.header .header-menu .pure-menu-heading span {
  margin-left: 10px;
  font-style: italic;
  text-transform: capitalize;
}
.header-menu .pure-menu-search {
  width: 38.6%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
}
.pure-menu-search #search-grapes {
  height: 53px;
  box-sizing: border-box;
  border-width: 0;
  background: transparent;
  color: #fff;
  width: 100%;
  outline: none!important;
  padding: 0 120px 0 20px;
  font-size: 22px;
  font-weight: 400;
}
.pure-menu-search #search-grapes::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: #eee;
}
.pure-menu-search #search-grapes::-moz-placeholder { /* Firefox 19+ */
  color: #eee;
}
.pure-menu-search #search-grapes:-ms-input-placeholder { /* IE 10+ */
  color: #eee;
}
.pure-menu-search #search-grapes:-moz-placeholder { /* Firefox 18- */
  color: #eee;
}
.pure-menu-search .search-by {
  position: absolute;
  right: 40px;
  top: 0;
}
.pure-menu-search .search-by label {
  display: none; 
}
.pure-menu-search .search-by select {
  background: #333;
  border: 0;
  color: #fff;
  margin: 13px;
  outline: none;
}
.pure-menu-search .search-trigger {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 22px;
  color: #fff;
  line-height: 53px;
}
.pure-menu-search .search-trigger:hover {
  cursor: pointer;
  opacity: 0.8;
}
.header-menu .pure-menu-list {
  float: right;
  width: 20%;
  white-space: normal;
}
.header-menu .pure-menu-list > .pure-menu-item {
  width: 50%;
  float: left;
}
.header-menu .pure-menu-list > .pure-menu-item:last-child {
  float: right;
}
.header-menu .pure-menu-list > .pure-menu-item > a {
  line-height: 53px;
  padding-top: 0;
  padding-bottom: 0;
  text-align: center;
  color: #fff;
}
.header-menu .pure-menu-list > .pure-menu-item:hover > a, .header-menu .pure-menu-list > .pure-menu-link:hover {
  color: #fff;
  background-color: #6c7680;
}
.header-menu .pure-menu-children {
  background: transparent;
  width: auto;
  left: auto;
  right: 4px;
  padding-top: 4px;
  min-width: 130px;
  font-weight: 100;
}
.header-menu .pure-menu-children .pure-menu-item a {
  color: #fff;
  background: #485057;
}
.header-menu .pure-menu-children .pure-menu-item:hover a {
  color: #fff;
  background-color: #6c7680;
}
.header-menu .pure-menu-children .pure-menu-link {
  padding: 0.5em 1.4em;
}
.pure-menu-horizontal .pure-menu-has-children>.pure-menu-link:after {
  display: none;
}
#welcome {
  float: right;
  color: #fff;
  line-height: 46px;
  margin-right: 20px;
  display: block;
  font-size: 14px;
}
#main-col > h3 {
  font-weight: 100;
  text-transform: uppercase;
  font-size: 20px;
  margin-bottom: 30px;
}
.admin-header .header-menu .pure-menu-heading span {
  font-weight: bold;
  color: #36a731;
  opacity: 0.8;
}
.admin-header .header-menu .pure-menu-list {
  width: auto;
}
.admin-header .header-menu .pure-menu-item {
  width: auto;
}
.mobile-menu {
  width: 100vw;
}
.mobile-menu .pure-menu-heading {
  float: left;
  margin-left: 0;
  padding-left: 20px;
}
.mobile-menu > .pure-menu-list {
  float: right;
  width: auto;
  margin-right: 10px;
}
.mobile-menu .pure-menu-item > a {
  padding: 0 10px;  
}
.mobile-menu .open-menu-item > a {
  padding: 17px 15px;
}
.mobile-menu .pure-menu-list .grapevines svg {
  height: 32px;
  vertical-align: -9px;
  width: 32px;
}
.mobile-menu .open-menu-item i {
  font-size: 1.2em;
  color: #fff;
  vertical-align: -1px
}
.mobile-menu > .pure-menu-list > .pure-menu-item {
  width: auto;
}
.mobile-menu .pure-menu-list .create-grape svg {
  height: 16px;
  vertical-align: -2px;
  width: 16px;
}
.mobile-quick-nav {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  background: #eee;
  transform: translateY(-100%);
  -moz-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  -webkit-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
}
.mobile-quick-nav.mobileMenuShow {
  transform: translateY(0);
}
.mobile-quick-nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
  height: auto;
  overflow: hidden;
  z-index: 3;
  background: #eee;
}
.mobile-quick-nav ul > li {
  float: left;
  width: 21%;
  text-align: center;
}
.mobile-quick-nav ul > li.back {
  width: 16%;
  opacity: 0.7;
}
.mobile-quick-nav ul > li a {
  color: #222;
  text-decoration: none;
  display: block;
  height: 53px;
  padding: 9px 0;
  box-sizing: border-box;
}
.mobile-quick-nav ul > li i {
  display: block;
  font-size: 1.3em;
  margin-bottom: 2px;
}
.mobile-quick-nav ul > li.back i {
  margin-bottom: 0;
  line-height: 35px;
  letter-spacing: 6px;
}
.mobile-quick-nav ul > li span {
  display: block;
  font-size: 0.8em;
}
.mobile-search {
  height: 44px;
  z-index: 2;
  background: #fff;
  position: absolute;
  top: 0;
  width: 100%;
  box-sizing: border-box;
  height: auto;
  overflow: hidden;
  border-bottom: 1px solid #ccc;
  transform: translateY(0);
  -moz-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  -webkit-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
}
.mobile-search input {
  width: 100%;
  height: 44px;
  padding: 0 48px 0 20px;
  border-width: 0;
  box-sizing: border-box;
}
.mobile-search .search-trigger {
  position: absolute;
  right: 12px;
  top: 50%;
  font-size: 18px;
  margin-top: -17px;
  padding: 6px 14px;
}
.mobileSearchShow .mobile-search {
  transform: translateY(53px);
}
#mobile-header-progress {
  width: 0px;
  height: 6px;
  background: #36a731;
  z-index: 4;
  position: fixed;
}
.grapes-list {
  padding-left: 0;
  list-style: none;
  margin-top: 0;
  margin-bottom: 30px;
}
.grapes-list li {
  padding: 15px 30px 15px 38px;
  position: relative;
  height: auto;
  overflow: hidden;
  border-bottom: 1px solid #ececec;
}
.grapes-list li .grape-img-link {
  display: inline-block;
  float: left;
  width: 26px;
  margin-right: 12px;
  position: absolute;
  top: 19px;
  left: 0;
}
.grapes-list li .grape-img-link > img {
  width: 100%;
  height: auto;
}
.grapes-list li a {
  text-decoration: none;
  color: #222;
  font-size: 15px;
}
.grapes-list li .grape-title {
  font-weight: bold;
}
.grapes-list li .grape-author {
  font-size: 0.8em;
  padding-top: 4px;
  display: block;
}
.grapes-list li .remove-grape {
  position: absolute;
  right: 0;
  top: 40%;
  margin-top: -9px;
  font-size: 0.8em;
}
.is-read-only .grapes-list li .remove-grape {
  display: none;
}
.grapevines-list {
  list-style: none;
  margin: 0 0 30px;
  padding: 0;
}
.grapevines-list li {
  text-transform: lowercase;
  color: #ccc;
  position: relative;
  text-align: center;
  -moz-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  -webkit-transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  transition: all 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
}
.grapevines-list li:hover {
  cursor: pointer
}
.grapevines-list li .hover-line {
  background: #36a731;
  height: 1px;
  width: 0;
  display: inline-block;
  vertical-align: -3px;
  transition: all 1.2s cubic-bezier(0.075, 0.820, 0.165, 1.000);
}
.grapevines-list li:hover .hover-line {
  width: 100%;
}
.grapevines-list li a {
  text-decoration: none;
  padding: 10px 0;
  display: block;
  color: #222;
  text-align: left;
  height: auto;
  overflow: hidden;
  margin-bottom: -20px;
}
.grapevines-list li .grape-img {
  display: inline-block;
  float: left;
  width: 26px;
  min-height: 36px;
  margin-right: 12px;
}
.grapevines-list li a .grapevine-name {
  font-weight: 100;
  display: inline-block;
  max-width: 80%;
  max-width: calc(100% - 38px);
}
.grapevines-list li.top-rated {
  text-transform: none;
}
.grapevines-list li.top-rated a .grapevine-name {
  text-decoration: underline;
}
@media only screen and (max-width: 767px) {
  .grapevines-list li.top-rated a .grapevine-name {
    max-width: none;
  }
  .grapevines-list li a {
    margin-bottom: 0;
  }
  .grapevines-list li .hover-line {
    display: none!important;
  }
}
.grapevines-list li a .grapes-count {
  display: block;
  font-size: 0.8em;
  padding-top: 4px;
  text-transform: none;
  font-weight: 700;
  padding-left: 38px;
}
.grapevines-list li a .grapes-count i {
  display: none;
}
.grapevines-list li svg, .grapevines-list li a > i {
  position: absolute;
  right: -6px;
  top: 50%;
  margin-top: -7px;
  color: #777;
  font-size: 0.8em;
  opacity: 1;
  -moz-transition: opacity 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  -webkit-transition: opacity 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
  transition: opacity 0.8s cubic-bezier(0.075, 0.820, 0.165, 1.000);
}
.grapevines-list li svg, .grapevines-list li a > i {
  display: none;
}
.grapevines-list li:hover svg, .grapevines-list li:hover a > i {
  opacity: 0.2;
}
.grapevines-list li[data-read-only="true"] svg, .grapevines-list li[data-read-only="true"] i, .grapevines-list li[data-private="true"] svg, .grapevines-list li[data-private="true"] i {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue